export default "__VITE_ASSET__Dhk53ad0__"